import * as React from 'react';

import {ListView} from 'shells/list-view/list-view';

import type {SmsDripSequenceFragment as DripSequence} from 'nutshell-graphql-types';

import {DripSequenceListItemWrapper} from './drip-sequence-list-item-wrapper';
import {EmptyState} from './empty-state';

type Props = {
    isLoading: boolean;
    isFiltering: boolean;
    isShowingArchived: boolean;
    error: string | null | undefined;
    dripSequences: DripSequence[];
    onCreateNewDripSequence: () => any;
    onDeleteDripSequence: (dripSequenceId: string) => Promise<any>;
    onDuplicateDripSequence?: (dripSequenceId: string) => any;
    onRestoreDripSequence: (dripSequenceId: string) => Promise<any>;
    isCreating: boolean;
};

export function DripSequencesBoardView(props: Props) {
    return (
        <ListView
            collection={props.dripSequences}
            itemSpacing={16}
            renderRow={(dripSequence) => {
                return (
                    <div key={dripSequence.id} className='pb-16'>
                        <DripSequenceListItemWrapper
                            dripSequence={dripSequence}
                            isArchived={props.isShowingArchived}
                            onDeleteDripSequence={() => {
                                return props.onDeleteDripSequence(dripSequence.id);
                            }}
                            onRestoreDripSequence={() => {
                                return props.onRestoreDripSequence(dripSequence.id);
                            }}
                            onDuplicateDripSequence={props.onDuplicateDripSequence}
                        />
                    </div>
                );
            }}
            isLoading={props.isLoading}
            loadingState={{itemHeight: 152, listPadding: 0, backgroundColor: 'white'}}
            isError={Boolean(props.error)}
            errorState={{errorMessage: props.error}}
            isFiltering={props.isFiltering || props.isShowingArchived}
            nothingFoundState={{
                title: 'No drip sequences were found',
            }}
            emptyStateComponent={
                <EmptyState
                    onPrimaryCtaClick={props.onCreateNewDripSequence}
                    isCreating={props.isCreating}
                />
            }
        />
    );
}
